"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeRadio = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const rebass_1 = require("rebass");
const Radio_1 = tslib_1.__importDefault(require("../../components/Radio"));
const TypeRadio = (props) => (React.createElement(Radio_1.default, { onClick: () => props.onClick(), checked: props.checked },
    React.createElement(rebass_1.Flex, { flexDirection: "column" },
        React.createElement(rebass_1.Text, null, props.text),
        React.createElement(rebass_1.Text, { fontSize: 2, marginTop: 1 }, props.description))));
exports.TypeRadio = TypeRadio;
